"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeavrWebhookTypeEnum = void 0;
/** Weavr webhook payload discriminator (`webhookType` field). */
var WeavrWebhookTypeEnum;
(function (WeavrWebhookTypeEnum) {
    WeavrWebhookTypeEnum["KYB_UPDATE"] = "KYB_UPDATE";
    WeavrWebhookTypeEnum["BENEFICIARY_UPDATE"] = "BENEFICIARY_UPDATE";
    WeavrWebhookTypeEnum["WALLET_DEPOSIT"] = "WALLET_DEPOSIT";
    WeavrWebhookTypeEnum["CARD_AUTHORIZATION"] = "CARD_AUTHORIZATION";
    WeavrWebhookTypeEnum["CARD_SETTLEMENT"] = "CARD_SETTLEMENT";
    WeavrWebhookTypeEnum["CARD_EXPIRY"] = "CARD_EXPIRY";
    WeavrWebhookTypeEnum["OUTGOING_WIRE_TRANSFER"] = "OUTGOING_WIRE_TRANSFER";
    WeavrWebhookTypeEnum["MANUAL_TRANSACTION"] = "MANUAL_TRANSACTION";
    WeavrWebhookTypeEnum["MANAGED_CARD_STATE_CHANGE"] = "MANAGED_CARD_STATE_CHANGE";
})(WeavrWebhookTypeEnum || (exports.WeavrWebhookTypeEnum = WeavrWebhookTypeEnum = {}));
